import { Button } from "@mui/material";
import React from "react";

import { AutopilotUser } from "services/AutopilotService";

import ApiKeysTable from "./ApiKeysTable";
import FreeTierWarning from "./FreeTierWarning";
import NewApiKeyBanner from "./NewApiKeyBanner";
import styles from "../ProfilePage.module.scss";

interface ApiKeysTabProps {
  autopilotUser: AutopilotUser | null | undefined;
  loading: boolean;
  error: string | null;
  generatedApiKey: string | null;
  onClearGeneratedKey: () => void;
  subscriptionUpdateLoading: boolean;
  subscriptionReady: boolean;
  onUpgrade: () => void;
  onGenerateFirstKey: () => void;
  onAddNewKey: () => void;
  deleteLoadingPrefix: string | null;
  onDeleteKey: (prefix: string) => void;
}

const ApiKeysTab: React.FC<ApiKeysTabProps> = ({
  autopilotUser,
  loading,
  error,
  generatedApiKey,
  onClearGeneratedKey,
  subscriptionUpdateLoading,
  subscriptionReady,
  onUpgrade,
  onGenerateFirstKey,
  onAddNewKey,
  deleteLoadingPrefix,
  onDeleteKey,
}) => {
  const tier = autopilotUser?.company?.subscription_tier;
  const ready = !loading && !error;

  return (
    <>
      {generatedApiKey && (
        <NewApiKeyBanner
          apiKey={generatedApiKey}
          onClose={onClearGeneratedKey}
        />
      )}

      {ready && autopilotUser === null && (
        <div className={styles.developerEmptyState}>
          <Button className="slapShotButton" onClick={onGenerateFirstKey}>
            Generate API Key
          </Button>
        </div>
      )}

      {ready && tier === "free_tier" && (
        <FreeTierWarning
          loading={subscriptionUpdateLoading}
          framesUsed={autopilotUser?.company?.frames_used ?? 0}
          subscriptionReady={subscriptionReady}
          onUpgrade={onUpgrade}
        />
      )}

      {ready && autopilotUser && (
        <>
          <div className={styles.developerKeysHeader}>
            <h5>API Keys</h5>
            <Button
              onClick={onAddNewKey}
              sx={{
                background: "#6c63ff",
                borderRadius: "999px",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 500,
                padding: "6px 18px",
                textTransform: "none",
                whiteSpace: "nowrap",
                "&:hover": { background: "#5a52e0" },
              }}
            >
              + Add API Key
            </Button>
          </div>

          <ApiKeysTable
            apiKeys={autopilotUser.api_keys}
            deleteLoadingPrefix={deleteLoadingPrefix}
            onDelete={onDeleteKey}
          />
        </>
      )}
    </>
  );
};

export default ApiKeysTab;
